export default __webpack_public_path__ + "close.e3cea3af.svg";